import { useState, useRef, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import View from './View';
import Zoom from './Zoom';
import stores from '@stores';

export default observer(() => {
    const [target, setTarget] = useState(null);

    return (
        <div id="editor-container" className='flex-1 overflow-hidden select-none relative bg-white/80 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg mx-4 my-4 shadow-md'>
            <div className="w-full h-full relative z-0" ref={
                (node) => setTarget(node)
            }>
                {target && <View target={target} />}
            </div>
            <Zoom />
        </div>
    );
});
